import * as React from "react";
import { Box, Grid } from "@material-ui/core";
import { themeVariables } from "../MUI";
import * as styles from "./styles.scss";
import { tl } from "../../../utils";

type IProps = {
  isCustom: boolean;
  logo?: string | null;
};

export const SiteHeader = (props: IProps) => {
  return (
    <Box
      bgcolor={themeVariables.palette.headerColor}
      color={themeVariables.palette.headerTextColor}
      className={!props.isCustom ? !(window as any).isNewYear ? "" : `${styles.newYear}` : ''}
    >
      <Grid container justifyContent="space-between">
        <Grid item></Grid>
        
        <Grid item  className={!props.isCustom ? !(window as any).isNewYear ? "" : `${styles.lightsContainer}` : ''}>
          {
            !props.isCustom && (window as any).isNewYear &&
            <picture>
                <img className={styles.lights}
                     srcSet="/public/images/_anti/events/new_year/lights.png, /public/images/_anti/events/new_year/lights@2x.png 2x"
                     alt="lights"
                />
            </picture>
          }
          <a href="/" className="head__logo">
            {props.logo && <img src={props.logo} alt="" />}
            {!props.logo && !props.isCustom && <>{tl('АНТИ')}{tl('ТРЕНИНГИ')} </>}
          </a>
        </Grid>
        <Grid item></Grid>
      </Grid>
    </Box>
  );
};
